<template>
    <fieldset>
        <div class="checkbox">
            <label>
                <input type="checkbox"
                       name="newsletter_sign_up"
                       v-model="formData.newsletter_sign_up"
                >
                Feliratkozom a hírlevélre
            </label>
        </div>
    </fieldset>
</template>

<script>
export default {
    props: {
        loading: {
            required: true,
            type: Boolean,
        },
        formData: {
            required: true,
            type: Object,
        },
    },
}
</script>

<style scoped>

</style>
